import { render, staticRenderFns } from "./WaveForm.vue?vue&type=template&id=22213e99&scoped=true&"
import script from "./WaveForm.vue?vue&type=script&lang=js&"
export * from "./WaveForm.vue?vue&type=script&lang=js&"
import style0 from "./WaveForm.vue?vue&type=style&index=0&id=22213e99&scoped=true&lang=css&"
import style1 from "./WaveForm.vue?vue&type=style&index=1&id=22213e99&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22213e99",
  null
  
)

export default component.exports